export default __webpack_public_path__ + "static/media/WAS0333.34I-41679_-24955_0.b79d04f7.jpg";